import { NgModule } from '@angular/core';
import { SimCheckboxComponent } from './sim-checkbox.component';

@NgModule({
  declarations: [SimCheckboxComponent],
  exports: [SimCheckboxComponent],
  imports: []
})
export class SimCheckboxModule {}
